import { render } from "./MyBlogs.vue?vue&type=template&id=cdd6e6ea&scoped=true"
import script from "./MyBlogs.vue?vue&type=script&lang=js"
export * from "./MyBlogs.vue?vue&type=script&lang=js"

import "./MyBlogs.vue?vue&type=style&index=0&id=cdd6e6ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdd6e6ea"]])

export default __exports__